import {ServiceBase} from "../ServiceBase";
import {IFreePlayService} from "./free-play.service.interface";
import {IServiceFactoryExtended} from "../service-factory-extended.interface";
import {IFreePlayVouchersProvider} from "./providers/free-play-vouchers.provider.interface";
import {action, computed, observable} from "mobx";
import {IFreePlayVoucherModel} from "./vouchers/free-play-voucher.model.interface";
import {Tripe8FreePlayVouchersProvider} from "./providers/888/888-free-play-vouchers.provider";
import {FreePlayTooltipNotificationHandler} from "./free-play-tooltip-notification.handler";
import {ThirdPartyVouchersProvider} from "./providers/3rdparty/third-party-vouchers.provider";

export class FreePlayService extends ServiceBase implements IFreePlayService {
    constructor(services: IServiceFactoryExtended) {
        super(services);

        this._toolTipHandler = new FreePlayTooltipNotificationHandler(services, this);

        this.reaction(() => this.services.user.isAuthorized,
            (isAuthorized) => {
                if(isAuthorized) {
                    this._setVoucherProviders([
                        new Tripe8FreePlayVouchersProvider(this.services),
                        new ThirdPartyVouchersProvider(this.services)
                    ]);
                } else {
                    this._setVoucherProviders([]);
                }
            }, {
                fireImmediately: true
            });
    }

    private readonly _toolTipHandler: FreePlayTooltipNotificationHandler;
    setFreePlayIndicatorDOMElementRef(element: HTMLDivElement | null): void {
        this._toolTipHandler.setFreePlayIndicatorDOMElementRef(element);
    }

    @observable.ref
    private _vouchersProviders: IFreePlayVouchersProvider[] = [];

    @action.bound
    private _setVoucherProviders(newProviders: IFreePlayVouchersProvider[]): void {
        this._vouchersProviders.forEach(vp => vp.dispose());
        this._vouchersProviders = newProviders;
    }

    get hasVouchers(): boolean {
        return this.userVouchers.length > 0;
    }

    @computed
    get userVouchers(): IFreePlayVoucherModel[] {
        let allVouchers: IFreePlayVoucherModel[] = [];

        this._vouchersProviders.forEach(provider => {
            allVouchers = [
                ...allVouchers,
                ...provider.vouchers
            ];
        });

        return allVouchers.filter(voucher => voucher.isValid);
    }

    findVoucherById(id: string): IFreePlayVoucherModel | null {
        return this.userVouchers.find(v => v.id === id) || null;
    }

    getGameVouchers(gameType: number): IFreePlayVoucherModel[] {
        return this.userVouchers.filter(voucher => voucher.hasGame(gameType));
    }

}